import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { NO_REVIEW_AVAILABLE } from 'commons/constants';
import MixedGridCard from './MixedGridCard';
import MixedGridCardPlaceholder from './MixedGridCardPlaceholder';
const MixedGridItems = t0 => {
  const $ = _c(16);
  const {
    from: t1,
    loadingMore,
    data,
    hits,
    hoveredValue,
    layout,
    onHoverHandler,
    toggleModalView
  } = t0;
  const from = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== data || $[1] !== hits || $[2] !== hoveredValue || $[3] !== layout || $[4] !== onHoverHandler || $[5] !== toggleModalView) {
    t2 = !!data.length && data.map((card, index) => {
      let key;
      if (card.card_type === "customer_photo") {
        key = card.photo_id ? `photo-${card.photo_id}-${index}` : `photo-idx-${index}`;
      } else {
        key = card.id ? `${card.card_type || "item"}-${card.id}-${index}` : `${card.card_type || "item"}-idx-${index}`;
      }
      return <div key={key} className="mixed-grid-item max-[767px]:[&>*]:max-w-[100vw]"><MixedGridCard {...card} index={index} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} /></div>;
    });
    $[0] = data;
    $[1] = hits;
    $[2] = hoveredValue;
    $[3] = layout;
    $[4] = onHoverHandler;
    $[5] = toggleModalView;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== data.length || $[8] !== from) {
    t3 = !data.length && from === "review" && <div className="text-center font-normal">{NO_REVIEW_AVAILABLE}</div>;
    $[7] = data.length;
    $[8] = from;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== loadingMore) {
    t4 = loadingMore && <MixedGridCardPlaceholder />;
    $[10] = loadingMore;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
MixedGridItems.propTypes = {
  data: PropTypes.array,
  from: PropTypes.string,
  gridWithOneCol: PropTypes.bool,
  gridWithReviews: PropTypes.bool,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  isMixedGridTab: PropTypes.bool,
  keyId: PropTypes.string,
  layout: PropTypes.string,
  loading: PropTypes.bool,
  loadMore: PropTypes.func,
  loadingMore: PropTypes.bool,
  maxCardsCount: PropTypes.number,
  onHoverHandler: PropTypes.func,
  toggleModalView: PropTypes.func
};
export default MixedGridItems;